(() => {
  if (customElements.get('bp-book-animation')) return;
  class BookAnimation extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.replay = this.querySelector('[data-book-replay]');
      this.play = () => {
        if (this.motion.matches || document.hidden) return;
        this.classList.remove('is-playing');
        void this.getBoundingClientRect();
        this.classList.add('is-playing');
      };
      this.stopForPreference = () => { if (this.motion.matches) this.classList.remove('is-playing'); };
      this.replay?.addEventListener('click', this.play);
      this.motion.addEventListener?.('change', this.stopForPreference);
      // Play once when visible; the illustration then stays still until replayed.
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.play(); this.observer.disconnect(); }
        }, { threshold: 0.25 });
        this.observer.observe(this);
      } else { this.play(); }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.replay?.removeEventListener('click', this.play);
      this.motion?.removeEventListener?.('change', this.stopForPreference);
      this.initialised = false;
    }
  }
  customElements.define('bp-book-animation', BookAnimation);
})();
